import React, { forwardRef, useImperativeHandle } from 'react';

import * as General from '../General/General';
import * as rsuite from 'rsuite';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';


const Auto_ACCC = forwardRef((props, ref) => {

    const [List, setList] = React.useState([]);

    useImperativeHandle(ref, () => ({

        Bind(search, Acc_GLId) {
            console.dir(search)
            var RequestOptions = {
                data: {
                    'Title': search,
                    'Acc_GLId': Acc_GLId,
                    'IsActive': 1,
                },
                url: General.ApiRoute() + "/Account_Control/Search",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }
            trackPromise(
                axios(RequestOptions)
                    .then(result => {
                        var tmp = []
                        for (var i = 0; i < result.data.length; i++) {
                            tmp.push({
                                Row: i + 1,
                                value: result.data[i].value + "|" + result.data[i].label + "|" +
                                    result.data[i].code + "|" + result.data[i].financialBalance + "|" +
                                    result.data[i].sub_Acc_L1 + "|" + result.data[i].sub_Acc_L2 + "|" +
                                    result.data[i].sub_Acc_L3 + "|" + result.data[i].acc_GLId + "|" + result.data[i].acc_GL_Title + "|" +
                                    result.data[i].acc_GId + "|" + result.data[i].acc_G_Title,
                                label: result.data[i].label,

                            })
                        }

                        setList(tmp)



                    })
                    .catch((error) => {
                        console.dir(error)
                    })
            )

        },
        focus() {
            const inputElement = document.querySelector('.FocusACCCAuto input');
            if (inputElement) {
                inputElement.focus();
            }
        }
    }),
        [props.value])

    return (
        <rsuite.AutoComplete
            data={List.map((product) => ({
                label: `${product.label}`,
                value: `${product.value}`,
            }))}
            value={props.value}
            label={props.label}
            onChange={(event) => props.onChange(event)}
            onSelect={(event) => props.onSelect(event)}
            // onKeyUp={(event) => props.onKeyUp(event)}

            className='FocusACCCAuto'
        />)
});

export default Auto_ACCC;